import React, { useEffect, useState } from 'react';
import TaskTypeSelector from '../../task-types/components/TaskTypeSelector';
import { useGetTaskTypes } from '../../task-types/TaskType.hooks';
import { TaskType, TaskTypeEntity } from '../../task-types/TaskType.interface';

export interface DocumentTypeFilterProps {
  value?: string[];
  onChange?: (taskType: TaskType[] | null) => void;
}

const DocumentTypeFilter: React.FC<DocumentTypeFilterProps> = ({
  value,
  onChange
}) => {
  const [taskTypes, setTaskTypes] = useState<TaskType[]>([]);
  const [{ data, isLoading, error }, findTaskTypes] = useGetTaskTypes();

  useEffect(() => {
    findTaskTypes({ targetEntity: TaskTypeEntity.File });
  }, [findTaskTypes]);

  useEffect(() => {
    data && setTaskTypes(data);
  }, [data]);

  return (
    <TaskTypeSelector
      multiple={true}
      value={value}
      options={taskTypes}
      isLoading={isLoading}
      errorMessage={error?.message}
      textFieldProps={{
        label: '',
        placeholder: 'Choose a Document Type'
      }}
      onChange={onChange}
    />
  );
};

export default DocumentTypeFilter;
